import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BcmService } from '@modules/bcm/bcm.service';
import { BcmVoucher, BcmVoucherDto } from '@shared/models/bcm-voucher';
import { BcmBaseFacade } from '@modules/bcm/@core/state-management/bcm-base.facade';
import { BcmUserPermission } from '@modules/bcm/bcm-user-permission';
import { AppNotificationService } from '@core/services/app-notification.service';
import { ConfirmDialogService } from '@sharedComponents/dialogs/confirm-dialog/confirm-dialog.service';
import { vouchersTableData } from '@modules/bcm/@core/state-management/vouchers/bcm-vouchers-table-data';
import { BcmUserSettingsFacade } from '@bcmServices/settings/bcm-user-settings-facade';
import { BcmTenantPermission } from '@modules/bcm/bcm-tenant-permission';
import { filteredListExportHeaderActionBase } from '@modules/bcm/@core/state-management/filtered-list-export-header.util';
import { BcmNavigationService } from '@modules/bcm/bcm-navigation.service';
import { ThemePalette } from '@angular/material/core';

@Injectable({providedIn: 'root'})
export class BcmVouchersFacade extends BcmBaseFacade<BcmVoucher, BcmVoucherDto> {

    readonly resourcePath = 'vouchers';

    get resourceNameSingular(): string {
        return this._tolgee.translate('bcmVouchers.singular');
    }

    get resourceNamePlural(): string {
        return this._tolgee.translate('bcmVouchers.plural');
    }

    readonly resourceIconPlural = 'redeem';

    readonly resourceIconSingular = 'redeem';

    readonly deletePermission = BcmUserPermission.PRODUCTS_DELETE;

    readonly readPermission = BcmUserPermission.PRODUCTS_READ;

    readonly writePermission = BcmUserPermission.PRODUCTS_WRITE;

    readonly hideGenericExcelButton = true;

    readonly headerActions = [
        {
            titleKey: 'table.exportCurrentView',
            icon: 'table_view',
            onClick: () => this.exportTableAsExcel(),
            ...filteredListExportHeaderActionBase(),
        },
    ];

    readonly rowActions = [
        {
            titleKey: 'table.rowActionView',
            icon: 'assignment',
            iconColor: 'accent' as ThemePalette,
            onClick: (voucher: BcmVoucher) => this.bcmNavigationService.navigate('vouchers/' + voucher.id),
        },
        {
            titleKey: 'table.rowActionDelete',
            icon: 'delete',
            iconColor: 'warn' as ThemePalette,
            onClick: (voucher: BcmVoucher) => super.remove(voucher, voucher.title).subscribe(),
        }
    ];

    constructor(appNotificationService: AppNotificationService,
                confirmDialogService: ConfirmDialogService,
                bcmUserSettingsFacade: BcmUserSettingsFacade,
                httpClient: HttpClient,
                bcmService: BcmService,
                protected bcmNavigationService: BcmNavigationService,
    ) {
        super(
            BcmVoucher,
            vouchersTableData,
            bcmNavigationService,
            appNotificationService,
            confirmDialogService,
            bcmUserSettingsFacade,
            httpClient,
            bcmService
        );
    }

}
